import styled, { keyframes } from 'styled-components';

import { Spinner } from '@ovpn-ui/core';
import { styledIf } from '@ovpn-ui/styles';

const showAfterDelay = keyframes`
    99% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

const Wrapper = styled.div<{ $delayed?: boolean; $withSidebarOffset?: boolean }>`
    position: absolute;
    top: 50%;
    left: ${t => (t.$withSidebarOffset ? 'calc(50% + var(--sidebar-left-offset, 0) / 2)' : '50%')};

    transform: translate(-50%, -50%);
    ${styledIf('$delayed')`
        opacity: 0;
    
        animation: 500ms ${showAfterDelay};
        animation-fill-mode: forwards;
    `}
`;

export function PageLoader({
    className,
    delayed,
    withSidebarOffset,
}: {
    className?: string;
    /**
     * Use when loader is used as Suspense fallback
     */
    delayed?: boolean;
    /**
     * Use when loader is placed outside MFWrapper, thus it cannot account for sidebar with
     * (which will place loader off-center).
     */
    withSidebarOffset?: boolean;
}) {
    return (
        <Wrapper className={className} $delayed={delayed} $withSidebarOffset={withSidebarOffset}>
            <Spinner size={24} />
        </Wrapper>
    );
}
